import useSWRImmutable from 'swr/immutable'

import { useApis } from '@/legacy-src/contexts/api-context'
import { useCompanyBenefitsSearchParams } from '@/legacy-src/hooks/useCompanyBenefitsSearchParams'
import type { ApisType } from '@/legacy-src/store/createApis'

const fetchCompanyData = async (api: ApisType['api'], slug: string, activationLinkId?: string, token?: string) => {
  const result = await api.getCompany(slug as string, activationLinkId as string, token as string)
  return result.data
}

export const useCompanyBenefitsActivationLinkValidity = (slug: string) => {
  const { api } = useApis()
  const { activationLinkId, token } = useCompanyBenefitsSearchParams()

  const { data, isLoading } = useSWRImmutable(['useLinkValidity', slug, activationLinkId, token], () =>
    fetchCompanyData(api, slug, activationLinkId, token),
  )

  return { linkIsValid: data?.activationLinkValid, isLoadingLinkValidity: isLoading }
}
